import { AutoSaveList } from '../../../../../common';
import DiagnosisFields from './DiagnosisFields';
import {
  EMPTY_MEDICAL_DIAGNOSIS_VALUES,
} from './constants';
import { MEDICAL_DIAGNOSIS_SCHEMA } from './validationSchema';
import {
  getMedicalDiagnosisDeleteMessage,
  getMedicalDiagnosisLabel,
  mapMedicalDiagnosisRowToValues,
  toMedicalDiagnosisFieldPayload,
} from './utils';

import type { MedicalDiagnosisFormValues } from '../types';
import type { AdditionalDiagnosisListProps } from './types';
import type {
  ITreatmentPlanV3MedicalDiagnosis,
  TreatmentPlanV3MedicalDiagnosisPayload,
} from '../../../../../../store/treatmentPlanV3';

export default function AdditionalDiagnosisList({
  entries,
  disabled,
  isSaving,
  onCreate,
  onUpdate,
  onDelete,
}: AdditionalDiagnosisListProps) {
  return (
    <AutoSaveList<
      MedicalDiagnosisFormValues,
      ITreatmentPlanV3MedicalDiagnosis,
      TreatmentPlanV3MedicalDiagnosisPayload
    >
      addButtonLabel="Add diagnosis"
      disabled={disabled}
      emptyValues={EMPTY_MEDICAL_DIAGNOSIS_VALUES}
      entries={entries}
      getDeleteConfirm={(row) => ({
        title: 'Confirm diagnosis deletion?',
        message: getMedicalDiagnosisDeleteMessage(row),
      })}
      getRowKey={(row) => row.id}
      getRowLabel={getMedicalDiagnosisLabel}
      isSaving={isSaving}
      mapRowToValues={mapMedicalDiagnosisRowToValues}
      newEntryLabel="New diagnosis"
      onCreate={onCreate}
      onDelete={onDelete}
      onUpdate={onUpdate}
      renderFields={({ backgroundColor, formik, disabled: rowDisabled, readOnly, saveField }) => (
        <DiagnosisFields
          backgroundColor={backgroundColor}
          disabled={rowDisabled}
          formik={formik}
          readOnly={readOnly}
          saveField={saveField}
        />
      )}
      requireCompleteDraft
      toFieldPayload={toMedicalDiagnosisFieldPayload}
      validationSchema={MEDICAL_DIAGNOSIS_SCHEMA}
    />
  );
}
